import React, { useEffect, useState } from 'react';
import useGlobal from '../../store';
import { getSiteBuildings, getAllBuildings } from '../../services/MetadataService';
import BuildingList from '../../components/BuildingList';

const BuildingResults = (props) => {
    const [buildings, setBuildings] = useState();
    const location = 'Buildings';
    let [currentState, currentActions] = useGlobal();

    if (!buildings) {
        let site_id = (props && props.location) || props.siteId;
        if (site_id) {
            console.log("I have a site id! " + site_id)
            getSiteBuildings(site_id).then((response) => {
                response.sort((a, b) => (a.site_name > b.site_name ? 1 : -1));
                setBuildings(response);
            });
        } else {
            getAllBuildings().then((response) => {
                response.sort((a, b) => (a.site_name > b.site_name ? 1 : -1));
                setBuildings(response);
            });
        }
    }

    useEffect(() => {
        if (currentState.currentModule !== location) {
            currentActions.setCurrentModule(location);
        }
    }, [location]);

    return (
        <div className="layer3">
            <BuildingList buildings={buildings} />
        </div>
    );
};

export default BuildingResults;
